import React from "react";
import jwtDecode from "jwt-decode";
import { Row, Space, Typography, Button } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";

import styles from "./styles/AccountPage.module.css";
import { COLORS } from "../../../constants";

const { Title } = Typography;

function AccountPage() {
  const token = localStorage.getItem("token");
  const { loginAs } = jwtDecode(token);

  return (
    <div className={styles.container}>
      <center>
        <div className={styles.content}>
          <Row align="middle" justify="space-between" style={{ marginTop: 20 }}>
            <Link to={-1}>
              <ArrowLeftOutlined style={{ fontSize: 20 }} />
            </Link>
            <Title level={3} style={{ textAlign: "left" }}>
              Accounts
            </Title>
          </Row>
          <div className={styles.info}>
            <Space
              size={"middle"}
              direction={"vertical"}
              style={{ width: "100%" }}
            >
              <Link to={"my-account"}>
                <Button block type="primary">
                  My Account
                </Button>
              </Link>

              {loginAs === "Administrator" && (
                <>
                  <Link to={"./create"}>
                    <Button block type="primary">
                      Create User Account
                    </Button>
                  </Link>
                  <Link to={"./view"}>
                    <Button
                      style={{
                        backgroundColor: COLORS.orange,
                        borderColor: COLORS.orange,
                      }}
                      block
                      type="primary"
                    >
                      View User Account
                    </Button>
                  </Link>
                </>
              )}
            </Space>
          </div>
        </div>
      </center>
    </div>
  );
}

export default AccountPage;
